import styled from 'styled-components';
import Tabs from '../../components/Tabs';

const StyledSubscriptionPageContainer = styled.div`
  padding: 24px;
  min-height: calc(100vh - 24px - 66px);
`;

const StyledTabs = styled(Tabs)`
  .ant-tabs-content-holder {
    background-color: unset;
    border: unset;
    min-height: unset;
    padding: unset;
  }
  
  .ant-tabs-nav {
    .ant-tabs-tab {
      &.ant-tabs-tab-active {
        border-color: ${props => props.theme.colors.neutral_4};
        border-bottom-color: ${props => props.theme.colors.neutral_1};
      }
    }
  }
`;

export {
  StyledSubscriptionPageContainer,
  StyledTabs
};
